import { Component, ElementRef, HostListener, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
interface Language {
  code: string;
  name: string;
  flag: string; // CSS class or SVG path
}
@Component({
  selector: "app-dots",
  templateUrl: "./dots.component.html",
  standalone: false,
  styles: [
    `
      language-selector {
        position: relative;
        display: inline-block;
      }

      .flag-icon {
        height: 28px;
        width: 28px;
        border-radius: 50%;
        object-fit: cover;
      }

      .dropdown-item {
        padding: 8px 12px;
        cursor: pointer;
      }

      .dropdown-menu {
        margin-top: 0 !important;
        top: 100% !important;
      }
      .dropdown-menu-header {
        margin-top: 0 !important;
      }
      [ngbdropdownmenu] {
        margin-top: 0 !important;
        padding-top: 0 !important;
      }
      .language-icon {
        margin: 0 !important;
      }
      .no-hover-style:hover {
        color: inherit !important;
      }
    `,
  ],
})
export class DotsComponent implements OnInit {
  key = "language";
  language = "";

  languageMap = {
    en: "us",
    hi: "in",
    fr: "fr",
  };
  languages: Language[] = [
    { code: "en", name: "English", flag: "assets/images/flags/us.svg" },
    /*  { code: "fr", name: "French", flag: "./assets/images/flags/fr.svg" },
    { code: "es", name: "Spanish", flag: "./assets/images/flags/es.svg" },
    { code: "ru", name: "Russian", flag: "./assets/images/flags/ru.svg" }, */
  ];
  supportLanguages = ["en", "fr", "hi"];

  constructor(
    private translateService: TranslateService,
    private elementRef: ElementRef
  ) {
    this.translateService.addLangs(this.supportLanguages);
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    this.getIconCss();
    if (localStorage.getItem("language")) {
      this.language = localStorage.getItem("language");
      this.translateService.use(this.language);
    } else {
      const browserlang = this.translateService.getBrowserLang();

      console.log("Browser Language => ", browserlang);

      if (this.supportLanguages.includes(browserlang)) {
        this.translateService.use(browserlang);
        this.language = browserlang;
        localStorage.setItem(this.key, browserlang);
      } else {
        this.language = "en";
        localStorage.setItem(this.key, "en");
        this.translateService.use("en");
      }
    }
  }
  selectedLanguage: Language = this.languages[0];
  isOpen = false;

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }
  changeLanguage(code: string): void {
    const language = this.languages.find((lang) => lang.code === code);
    if (language) {
      this.selectedLanguage = language;
    }
  }
  /*  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  } */
  onChangeLanguage(selectedLanguage: string) {
    this.language = selectedLanguage;
    this.translateService.use(selectedLanguage);
    localStorage.setItem(this.key, this.language);
    self.document.defaultView["CustomIntro"].loadDataOnLanguageChange();
  }

  getIconCss() {
    return (
      "language-icon flag flag-icon-background flag-icon-" +
      this.languageMap[this.language]
    );
  }
}

/* 
inside .language-selector

 .btn {
          background: transparent;
          border: none;
          outline: none;
          box-shadow: none;
          &:hover {
            background-color: transparent;
          }
          &:focus,
          &:focus-visible {
            outline: none;
            box-shadow: none;
          }
        }
*/
